import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { useInitData, useLinkLikeClick } from '../../../../hooks'
import { getBudgetPlanProfilePathname } from '../../../../utils/link'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { formatBudgetPlanAmount } from './RequestProfileWidgetBudgetPlan.utils'
import { RequestProfileWidgetBudgetPlanActionButton } from './RequestProfileWidgetBudgetPlanActionButton'

import * as styles from './RequestProfileWidgetBudgetPlan.module.css'

function RequestProfileWidgetBudgetPlan({ isSkeleton, requestData }) {
  const { t } = useTranslation()

  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const budgetPlanData = requestData?.budgetPlan
  const hasBudgetPlan = Boolean(budgetPlanData?.id)
  const currencyCode = budgetPlanData?.currency?.code

  const totalEstimatedAmount = formatBudgetPlanAmount(
    budgetPlanData?.total_estimated_amount,
    currencyCode
  )
  const totalInvoicesAmount = formatBudgetPlanAmount(
    budgetPlanData?.total_invoices_amount,
    currencyCode
  )
  const hasBudgetPlanValues = totalEstimatedAmount || totalInvoicesAmount

  function handleClickOpenBudgetPlan(event) {
    const link = getBudgetPlanProfilePathname({
      availableSections,
      id: budgetPlanData?.id,
      requestId: requestData.id,
    })

    handleClick({ event, link, target: HTML_LINK_TARGET.blank })
  }

  const actionButtonProps = {
    isAddAction: !hasBudgetPlan,
    onClick: handleClickOpenBudgetPlan,
  }

  const headerProps = {
    contentProps: {
      actionsProps: {
        AddButton: hasBudgetPlan
          ? null
          : RequestProfileWidgetBudgetPlanActionButton,
        EditButton: hasBudgetPlan
          ? RequestProfileWidgetBudgetPlanActionButton
          : null,
        ExpandButton: hasBudgetPlanValues ? undefined : null,
        addButtonProps: actionButtonProps,
        editButtonProps: actionButtonProps,
      },
    },
  }

  return (
    <Widget
      contentContainerProps={{
        className: styles.budgetPlanContent,
      }}
      headerProps={headerProps}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.BUDGET_PLAN}
      title={t('RequestProfile.BudgetPlanWidgetTitleKey')}
    >
      {hasBudgetPlanValues ? (
        <div className={styles.valuesContent}>
          {totalInvoicesAmount ? (
            <Text isSecondary className={styles.totalInvoicesLabel}>
              {t('RequestProfile.BudgetPlanWidgetInvoicesTitleKey')}
            </Text>
          ) : null}
          <FloatingTooltip
            content={
              <FloatingTooltipContentText
                text={t('Common.ClickToOpenProfileKey')}
              />
            }
            placement={FLOATING_ELEMENT_PLACEMENT.top}
          >
            <div className={styles.values} onClick={handleClickOpenBudgetPlan}>
              {totalInvoicesAmount ? <Text>{totalInvoicesAmount}</Text> : null}
              {totalEstimatedAmount ? (
                <Text isSecondary className={styles.estimatedAmount}>
                  {t('RequestProfile.BudgetPlanWidgetEstimatedAmountKey', {
                    amount: totalEstimatedAmount,
                  })}
                </Text>
              ) : null}
            </div>
          </FloatingTooltip>
        </div>
      ) : null}
    </Widget>
  )
}

export default RequestProfileWidgetBudgetPlan
